import request from '@/utils/request'

export function getSignList(query) {
  return request({
    url: '/hfsign/list',
    method: 'get',
    params: query
  })
}

export function batchSign(signList) {
  return request({
    url: '/hfsign/batch',
    method: 'post',
    data: { signList }
  })
}

export function checkSigned(processId) {
  return request({
    url: '/hfsign/check',
    method: 'get',
    params: { processId }
  })
}

// 已签收列表（当前登录用户已签收的流程）
export function getSignedList(query) {
  return request({
    url: '/hfsign/signed-list',
    method: 'get',
    params: query
  })
}

// 重新签收（刷新 OA 签收日期/时间并追加签收日志）
export function resignSign(data) {
  return request({
    url: '/hfsign/resign',
    method: 'post',
    data
  })
}

// 企业微信 code 直登（企业微信内打开应用 URL 自带 code）
export function qwLogin(params) {
  return request({
    url: '/hfsign/oauth/qw-login',
    method: 'get',
    params: params
  })
}

// 飞书 code 登录（跳飞书授权页回跳后带 code）
export function feishuLogin(params) {
  return request({
    url: '/hfsign/oauth/feishu-login',
    method: 'get',
    params: params
  })
}